import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { withFormsy } from '@akihirotakamura/formsy-react'
import _ from 'lodash'
import { Icon, Button, BaseForm as Form, Modal } from 'component/base'
import { PageContainer, Custom } from 'component/pieces'

export const Torihikisaki = withFormsy(props => {
  const {
    // Formsy props
    isPristine,
    errorLabel,
    getErrorMessage,
    setValue,
    getValue,

    // other
    defaultValue,
    value,
    icon,
    multiple,
    onChange,
    name,
    label,
    ichigen,
    clearable,
    ...other
  } = props

  const [showModal, setShowModal] = useState(false)
  const [savedValue, setSavedValue] = useState(value)
  const [selectedId, setSelectedId] = useState('')
  const [showDattai, setShowDattai] = useState(false)

  useEffect(() => {
    if (defaultValue || value) {
      setValue(defaultValue || value)
      setSavedValue(defaultValue || value)
    }
  }, [])

  useEffect(() => {
    if (!_.isEqual(value, savedValue)) {
      setValue(value)
      setSavedValue(value)
    }
  }, [value])

  const handleDecision = () => {
    setShowModal(false)
    setValue(multiple ? selectedId : selectedId[0])
    if (onChange)
      onChange(null, { value: multiple ? selectedId : selectedId[0] })
  }

  const handleChange = (e, data) => {
    setValue(data ? data.value : '')
    if (onChange) onChange(e, data, true)
  }

  return (
    <>
      <Form.Dropdown.WithAPI
        name={name}
        label={label}
        defaultValue={defaultValue}
        value={getValue()}
        url='/api/staff/master/torihikisaki/slim'
        icon={
          <Icon
            name='search'
            inverted
            circular
            link
            onClick={() => {
              if (clearable && getValue()) return
              setShowModal(true)
            }}
          />
        }
        multiple={multiple}
        onChange={handleChange}
        clearable={clearable}
        header={
          <Form.Checkbox.Buttony
            checked={showDattai}
            name='showDattai'
            label={showDattai ? '脱退者を表示' : '脱退者を非表示'}
            onClick={() => setShowDattai(v => !v)}
          />
        }
        editOptions={options => {
          const currentValue = getValue()
          const selectedIds = multiple ? currentValue || [] : currentValue ? [currentValue] : []

          return _(options)
            .filter(option => {
              return (
                showDattai ||
                !option.dattai_date ||
                selectedIds.includes(option.torihikisaki_id)
              )
            })
            .map(option => ({
              key: option.torihikisaki_id,
              value: option.torihikisaki_id,
              text: `${option.torihikisaki_cd}：${option.torihikisaki_name}`,
              torihikisaki_cd: option.torihikisaki_cd,
              dattai_date: option.dattai_date,
              label: {
                color: option.dattai_date ? 'red' : 'green',
                empty: true,
                circular: true,
              },
            }))
            .value()
        }}
        sort={['dattai_date', 'torihikisaki_cd']}
        sortOrders={['desc', 'asc']}
        key={`${showDattai}-${getValue()}`}
        {...other}
      />
      {showModal && (
        <Modal
          dimmer='inverted'
          open={showModal}
          closeOnDimmerClick
          size='fullscreen'
        >
          <Modal.Header content='取引先検索' />
          <Modal.Content image scrolling>
            <Modal.Description>
              <PageContainer style={{ width: '90vw' }}>
                <Custom.Block.Torihikisaki
                  multiple={multiple}
                  setSelectedId={setSelectedId}
                  selectedId={getValue()}
                />
              </PageContainer>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => setShowModal(false)} content='キャンセル' />
            <Button
              icon='checkmark'
              labelPosition='right'
              content='選択'
              onClick={handleDecision}
              primary
            />
          </Modal.Actions>
        </Modal>
      )}
    </>
  )
})

Torihikisaki.propTypes = {
  keyName: PropTypes.string,
  valueName: PropTypes.string,
  textName: PropTypes.string,
}

Torihikisaki.defaultProps = {
  keyName: 'torihikisaki_id',
  valueName: 'torihikisaki_id',
  textName: 'torihikisaki_name',
  validationErrors: {
    isDefaultRequiredValue: '必須です',
  },
}
